import React, { useState } from 'react';
import Parse from 'parse';
import $ from "jquery";
//import ImageCropper from './ImageCropper.jsx';
//import { resizeFile } from 'react-image-file-resizer';
class Photo extends React.Component {
    constructor(props) {
        super(props);
        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        let currentUser = Parse.User.current();   
        
        if(!currentUser)
        {
            window.location.href = "/";
        }

       
        let profile_picture = currentUser.get("profilePictureMedium");
        if(profile_picture)
        {
            profile_picture=profile_picture._url;
            $("#profilePicturePreview").attr("style", "display: block");
        }else
        {
            profile_picture='';
            $("#profilePicturePreview").attr("style", "display: none");
        }
        

        this.state = {
            caption:'',
            profile_picture:profile_picture,
            currentUser:currentUser,
           // originalImage: null,
            //croppedImages: [],
            parseFile_210:'',
            parseFile_640:''
        };

        this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
  
    }

handleFileChange = (event) => {
    const file = event.target.files[0];   
    if (file) {
                let imageFile = event.target.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                var img = document.createElement("img");
                img.onload = function (event) {
                var custom_width_640=640;
                var custom_width_210=210;
                if(custom_width_640)
                {
                    var canvas = document.createElement("canvas");
                    const canvasResize = document.createElement('canvas');
                    const ctxResize = canvasResize.getContext('2d');
                    
                    const maxWidth = 1000; 
                    const maxHeight = 1000; 
                    const aspectRatio = img.width / img.height;
                    let newWidth = img.width;
                    let newHeight = img.height;

                    if (img.width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = newWidth / aspectRatio;
                    }
                    if (newHeight > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = newHeight * aspectRatio;
                    }

                    canvasResize.width = newWidth;
                    canvasResize.height = newHeight;
                    ctxResize.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);

                    const resizedDataURL = canvasResize.toDataURL('image/jpeg');

                    const canvasCrop = document.createElement('canvas');
                    const ctxCrop = canvasCrop.getContext('2d');
                    const cropWidth = custom_width_640;
                    const cropHeight = custom_width_640;
                    canvasCrop.width = cropWidth;
                    canvasCrop.height = cropHeight;

                    const x = (newWidth - cropWidth) / 2;
                    const y = (newHeight - cropHeight) / 2;

                    ctxCrop.drawImage(canvasResize, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const croppedDataURL = canvasCrop.toDataURL('image/jpeg');                  
                    var dataurl_640 = croppedDataURL;
                 

                }
                if(custom_width_210)
                {
                    var canvas = document.createElement("canvas");
                    const canvasResize = document.createElement('canvas');
                    const ctxResize = canvasResize.getContext('2d');
                    
                    const maxWidth = 500; 
                    const maxHeight = 500; 
                    const aspectRatio = img.width / img.height;
                    let newWidth = img.width;
                    let newHeight = img.height;

                    if (img.width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = newWidth / aspectRatio;
                    }
                    if (newHeight > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = newHeight * aspectRatio;
                    }

                    canvasResize.width = newWidth;
                    canvasResize.height = newHeight;
                    ctxResize.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);

                    const resizedDataURL = canvasResize.toDataURL('image/jpeg');
                    const canvasCrop = document.createElement('canvas');
                    const ctxCrop = canvasCrop.getContext('2d');
                    const cropWidth = custom_width_210;
                    const cropHeight = custom_width_210;
                    canvasCrop.width = cropWidth;
                    canvasCrop.height = cropHeight;

                    const x = (newWidth - cropWidth) / 2;
                    const y = (newHeight - cropHeight) / 2;
                    ctxCrop.drawImage(canvasResize, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const croppedDataURL = canvasCrop.toDataURL('image/jpeg');
                    var dataurl_210 = croppedDataURL;
                }

                const dataurl_210s = document.getElementById('dataurl_210');
                dataurl_210s.value = dataurl_210;
                const dataurl_640s = document.getElementById('dataurl_640');
                dataurl_640s.value = dataurl_640;               
               
                const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
                const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });

                parseFile_640.save().then((savedFile) => {
                 const dataurl_640_img = document.getElementById('dataurl_640_img');
                 dataurl_640_img.value = savedFile.url();
                }).catch((error) => {
                  console.error('Error saving file:', error);
                });
                parseFile_210.save().then((savedFile) => {
                 const dataurl_210_img = document.getElementById('dataurl_210_img');
                 dataurl_210_img.value = savedFile.url();
                }).catch((error) => {
                  console.error('Error saving file:', error);
                });

                 document.getElementById("profilePicturePreview").src = dataurl_640;
                    
            }
                    img.src = e.target.result;
                }
                reader.readAsDataURL(imageFile);
            }

  };


    handlePhotoSubmit(event) {
     event.preventDefault();
     var forms = document.forms.new_photo_form;
     var caption=forms.caption.value;
     var dataurl_210=forms.dataurl_210.value;
     var dataurl_640=forms.dataurl_640.value;
     //var isChallenge="0";
    
     var dataurl_210_img=forms.dataurl_210_img.value;
     var dataurl_640_img=forms.dataurl_640_img.value;

     if(caption==='')
         {
           window.alert('Please write some caption first!');
         }else
         {
            const currentUser = Parse.User.current();
            if (currentUser) {      

                const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
                const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });
                const Photo = Parse.Object.extend('Photo');
                const photo = new Photo();
                let currentUser = Parse.User.current(); 
            
                photo.set('image', parseFile_640);  
                photo.set('thumbnail', parseFile_210);
                photo.set('nonMealPost', 1);
                photo.set('user', currentUser);
                photo.set('caption', caption);
                photo.set('fulltext', caption);                
                    photo.save().then((photodata) => {
                      setTimeout(() => {
                       $("#caption").val('');
                        window.alert('Post publish successfully');
                        window.location.href = "/";
                        },1500);
                     }).catch((error) => {
                        console.log(error.message);
                     });               
            } else {
                //console.error('No user is currently logged in.');
            }
         }
    }


    render() {
       
        var fetchProfile_picture =this.state.profile_picture;
        
        const currentUser = Parse.User.current();      
        let profile_pictures = currentUser.get("profilePictureMedium");
        
        if(profile_pictures)
        {  
            profile_pictures=profile_pictures._url; 
        }else
        {
        }

      
        var result = (
            <div className="form-photo photofrm container">
                <form className="form-signup"  id="new_photo_form" onSubmit={this.handlePhotoSubmit}>
                    <br/><br/>
                    <div className="container">
                  
        
        <div className="form_wrapper">
 <input type="file"  id="image-input"  onChange={this.handleFileChange}  />


        
         <p>
    

 </p>
  <p>
            <br/>
       
<div className="photo_section">
         <img height="" width="250" id="profilePicturePreview" src="/images/defaultcamera.png" alt="photo Picture" />

         <input type="hidden" id="photoUrlInput" name="photoUrl"/>
         <input type="hidden" id="dataurl_210" name="dataurl_210"/>
         <input type="hidden" id="dataurl_640" name="dataurl_640"/>
         <input type="hidden" id="dataurl_640_img" name="dataurl_640_img"/>
         <input type="hidden" id="dataurl_210_img" name="dataurl_210_img"/>

         
 </div>

<br/>
        
        </p>
<p>
          <textarea 
            placeholder="Write a caption..."
            size="large"
            name="caption"
            id="caption"
            className="form_input"
             
          />
          </p>
          <p>
     {/*  <div className="form-check">
  <input className="form-check-input" type="checkbox" value="1" name="isChallenge" id="isChallenge"/>
  <label className="form-check-label" for="isChallenge">
    Challenge
  </label>
</div>*/} 
<br/>


</p>

<div className="form_buttons"><br/>
      
        <button
            type="primary"
            className="form_button  btn btn-success"
            color={'#208AEC'}
            size="large"
          >
           Share
          </button>
         <br/><br/>
        </div>



         
        </div>
       
                    <br/>
                

 </div>

                </form>
                
            </div>

        );
       
        return result;
      

    }


}

export default Photo;


// WEBPACK FOOTER //
// ./src/Photo.jsx